import { Component, inject } from "@angular/core";
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { MatFormField, MatInput, MatHint, MatError } from "@angular/material/input";
import { TranslatePipe } from "@ngx-translate/core";


@Component({
    selector: "app-confirm-popup",
    templateUrl: "./confirm-popup.component.html",
    styleUrls: ["./confirm-popup.component.scss"],
    imports: [MatButton, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatHint, MatError, TranslatePipe]
})
export class ConfirmPopupComponent {
  private readonly dialogRef = inject<MatDialogRef<ConfirmPopupComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  public justificationRequired:boolean=this.data.title==="Rejecting the Access Request?";
  form = new FormGroup({
    Justification: new FormControl(null, [
      Validators.required,
      Validators.minLength(10),
      Validators.maxLength(500),
    ]),
  });

  /* #region Events and Methods */
  /** This method is to close the pop up*/
  public dismiss(): void {
    this.dialogRef.close(false);
  }

  /** This method is to close the pop up and to pass confirmation action */
  public confirmed(): void {
    if(this.justificationRequired){
      this.form.controls.Justification.markAsTouched();
    }
    if(this.form.valid || !this.justificationRequired){
      this.dialogRef.close(this.form.controls.Justification.value?this.form.controls.Justification.value:true);
    }
  }
  /* #endregion */

  /** This method is to close the pop up and to pass confirmation action */
  public cancelAction(): void {
    this.dialogRef.close();
  }

  public buildConfirmPopupId(controlId: string): string {
    return `confirm-popup-${controlId}`;
  }
  /* #endregion */
}
